// Lib
import React from 'react';
import { useTranslator } from '../../components/i18n/useTranslator';
import PropTypes from 'prop-types';

// Components
import FullScreenErrorModal from '../../components/modal/FullScreenErrorModal';
import ModalActionsList from '../../components/modal/ModalActionsList';

const PlatformUnsupportedFullScreenWarning = (props) => {
    const translate = useTranslator('modal', 'platform.unsupported');
    const actions = [
        { text: translate('chromeInstallLink'), href: 'https://www.google.com.au/chrome/' },
        { text: translate('continueButton'), func: props.acknowledgeUnsupportedBrowser },
    ];

    return (
        <FullScreenErrorModal>
            <h2>{translate('title')}</h2>
            <p className="explanation">
                {translate('description')}
                {' '}
                {translate('recommendation')}
            </p>
            <ModalActionsList actions={actions} />
        </FullScreenErrorModal>
    );
};

PlatformUnsupportedFullScreenWarning.propTypes = {
    acknowledgeUnsupportedBrowser: PropTypes.func.isRequired,
};

export default PlatformUnsupportedFullScreenWarning;
